import { InputValidatorType, plainText } from '../../../../../../../modules/validators';
import { trimSpacesLeft } from '../../../../../../../modules/formatters';
import { FormVmItemConfigType, FormVmValueValidatorResultType } from '../../../../../../../infrastructure/form-viewmodel-controller';
import { ApprovalType } from '../../../../../../_events/_manage-event/shared/connections-list/_create-zoom-webinar-modal/create-zoom-webinar-form-data.viewmodel';
import { buildConfigList } from '../../../../../../../infrastructure/utils/form-config.utils';

/* This enum is used for both ZoomMeeting and ZoomWebinar connection templates */
export enum FieldKey {
    TYPE = 'type',
    LABEL = 'label',
    GROUP = 'zoomGroupId',
    AUTO_REGISTRATION_ENABLED = 'autoRegistrationEnabled',
    AUTO_SYNC_ENABLED = 'autoSyncEnabled',
    AUTO_APPROVAL_ENABLED = 'approvalType',
    REGISTRATION_ENABLED = 'registrationEnabled',
    REGISTRATION_EMAILS_ENABLED = 'registrantsConfirmationEmail',
    AUTO_RECORDING = 'autoRecording',
    MEETING_UNIQUE_REFERENCE = 'meetingUniqueReference',
    PANELIST_LINK_CREATION_ENABLED = 'panelistLinkCreationEnabled'
}

export const zoomGroupValidator: InputValidatorType = (val: number = 0): FormVmValueValidatorResultType => {
    const valid = val >= 0 && !Number.isNaN(val);
    const validationMessage = valid
        ? null
        : { id: 'oe.validation.zoomGroup.message', defaultMessage: 'Zoom Group is required field' }
    ;

    return { valid: valid, validationMessage: validationMessage };
};

/* Common config for ZoomMeeting and ZoomWebinar connection template forms */
export const FORM_CONFIG = {
    [FieldKey.LABEL]: {
        labelDescriptor: { id: 'oe.templates.connection.label', defaultMessage: 'Label', description: 'Label text' },
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]
    },
    [FieldKey.GROUP]: {
        labelDescriptor: { id: 'oe.event.zoomGroup', defaultMessage: 'Zoom Group', description: 'Label text' },
        validators: [zoomGroupValidator],
        defaultValue: -1,
    },
    [FieldKey.AUTO_REGISTRATION_ENABLED]: {
        defaultValue: false
    },[FieldKey.AUTO_SYNC_ENABLED]: {
        defaultValue: false
    },[FieldKey.AUTO_APPROVAL_ENABLED]: {
        defaultValue: ApprovalType.AUTOMATICALLY
    },[FieldKey.REGISTRATION_ENABLED]: {
        defaultValue: false
    },[FieldKey.REGISTRATION_EMAILS_ENABLED]: {
        defaultValue: true
    },[FieldKey.MEETING_UNIQUE_REFERENCE]: {
        label: 'Unique Reference',
        labelDescriptor: { id: 'oe.connection.uniqueReference', defaultMessage: 'Unique Reference', description: 'Label text' },
        valueOptions: [ { label: 'No Unique Reference', value: 0 }, 1, 2, 3, 4, 5 ],
    }
};

export const configList: FormVmItemConfigType[] = buildConfigList(FORM_CONFIG);
